import { render } from "./timeArea.vue?vue&type=template&id=b771158c&scoped=true"
import script from "./timeArea.vue?vue&type=script&lang=js"
export * from "./timeArea.vue?vue&type=script&lang=js"

import "./timeArea.vue?vue&type=style&index=0&id=b771158c&scoped=true&lang=css"

import exportComponent from "C:\\Project\\VuePro\\DTP\\dtp_index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b771158c"]])

export default __exports__